import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useMemo } from 'react';
import { ThemeMode } from '@/interfaces/widgetTheme';
import StyleVariables, { getWidgetAttrSelector } from '@/components/widget/misc/StyleVariables';
import ClientOnly from '@/components/ClientOnly';
import FontsLoader from '@/components/widget/misc/FontsLoader';
import { ThemeContext, getFontsToLoad, useThemeProvider, extractThemeConfig } from './hooks/useThemeProvider';
import { generateStyleVariables, useTheme, useThemeContext } from './hooks/useTheme';
import { SYSTEM_THEMES, SYSTEM_THEME } from './constants'; // Normalizes widget configuration with defaults

import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const normalizeWidget = widget => {
  return _objectSpread({
    themeMode: ThemeMode.Light
  }, widget);
};

const ThemeProvider = _ref => {
  let {
    children,
    widget,
    widgetTheme
  } = _ref;
  const widgetId = (widget === null || widget === void 0 ? void 0 : widget.id) || '';
  const config = normalizeWidget(widget || {});
  const themeConfig = extractThemeConfig(config);
  const contextValue = useThemeProvider({
    themeConfig,
    widgetConfig: widget.config,
    widgetTheme
  });
  return /*#__PURE__*/_jsxs(ThemeContext.Provider, {
    value: contextValue,
    children: [children, /*#__PURE__*/_jsx(ThemeAssets, {
      widgetId: widgetId
    })]
  });
}; // Renders theme-related client-side components


const ThemeAssets = _ref2 => {
  let {
    widgetId
  } = _ref2;
  const {
    theme
  } = useTheme();
  const {
    styleVariables,
    fontsToLoad
  } = useMemo(() => {
    return {
      styleVariables: generateStyleVariables(theme),
      fontsToLoad: getFontsToLoad(theme)
    };
  }, [theme]);
  return /*#__PURE__*/_jsxs(ClientOnly, {
    children: [/*#__PURE__*/_jsx(StyleVariables, {
      selector: getWidgetAttrSelector(widgetId),
      data: styleVariables
    }), /*#__PURE__*/_jsx(FontsLoader, {
      loadFonts: fontsToLoad
    })]
  });
};

export default ThemeProvider;
export { useTheme, useThemeContext, SYSTEM_THEMES, SYSTEM_THEME };